// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"8":"editor","236":"properties","687":"create"}[chunkId] || chunkId) + "." + {"8":"1d658551","236":"8900e0d7","240":"ce6bbb0b","687":"0ed874e5","871":"2afed76c"}[chunkId] + ".js";
};